import api from "./axios";

export const listTournaments = (page = 1, opts = {}) => {
  const q = new URLSearchParams({ page: String(page) });
  if (opts.search) q.set("search", opts.search);
  // Folder filter chips. Pass a folder UUID to filter to one folder;
  // the literal "none" selects tournaments not in any folder.
  if (opts.folder) q.set("folder", opts.folder);
  return api.get(`/api/competitions/tournaments/?${q.toString()}`);
};

export const getTournament = (id) =>
  api.get(`/api/competitions/tournaments/${id}/`);

export const createTournament = (payload) =>
  api.post("/api/competitions/tournaments/", payload);

export const updateTournament = (id, payload) =>
  api.put(`/api/competitions/tournaments/${id}/`, payload);

export const deleteTournament = (id) =>
  api.delete(`/api/competitions/tournaments/${id}/`);


// ─── Tournament folders ───────────────────────────────────────────────
// Per-tenant grouping containers. Deleting a folder is non-destructive:
// its tournaments fall back to Unfiled.

export const listTournamentFolders = () =>
  api.get(`/api/competitions/tournament-folders/?page=1`);

export const createTournamentFolder = (name) =>
  api.post("/api/competitions/tournament-folders/", { name });

export const renameTournamentFolder = (id, name) =>
  api.patch(`/api/competitions/tournament-folders/${id}/`, { name });

export const deleteTournamentFolder = (id) =>
  api.delete(`/api/competitions/tournament-folders/${id}/`);

// Bulk move — per-row PATCH. Fine for small N (page size).
export const moveTournamentsToFolder = (ids, folderId) =>
  Promise.all(
    ids.map((id) =>
      api.patch(`/api/competitions/tournaments/${id}/`, { folder: folderId })
    )
  );